<template>
  <!-- <el-row class="industryBox"> -->
      <p>技术分支地市排名</p>
      <div class="tag">
          <span v-for="item in options" :key="item.value" @click="cityChange(item.value)" :class="{'active': cityValue == item.value}">{{item.label}}</span>
          <!-- <span @click="handleChangeCity(1)" :class="{'active': areaName == '1'}">被动器件/</span>
          <span @click="handleChangeCity(2)" :class="{'active': areaName == '2'}">专用材料/</span>
          <span @click="handleChangeCity(3)" :class="{'active': areaName == '3'}">机电元器件/</span> -->

          <!-- <el-select
              v-model="cityValue"
              placeholder="更多"
              size="size"
              style="width: 110px"
              @change="cityChange"
              >
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
          </el-select> -->
      </div>
      <div id="areaEchart">
        <p>排名</p>
        <p>城市</p>
        <p>专利量</p>
      </div>
      <div id="areaEchart2">
        <div class="areaEchart" v-for="(item, i) in currentArea.attrs" :key="i">
          <p>{{item.order}}</p>
          <p>{{item.name}}</p>
          <p>{{item.value}}件</p>
        </div>
      </div>
  <!-- </el-row> -->
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
export default {
  name: "areaEchart",
  data(){
    return {
        deviceName: 'ele2',
    }
  },
  setup() {
    let timer = null;
    const areaDatas = [
      {
        branchName: '主动器件',
        attrs: [{
          name: '哈尔滨市',
          value: 1854,
          order: '1'
        },{
          name: '大庆市',
          value: 128,
          order: '2'
        },{
          name: '齐齐哈尔市',
          value: 29,
          order: '3'
        },{
          name: '牡丹江市',
          value: 21,
          order: '4'
        },{
          name: '佳木斯市',
          value: 19,
          order: '5'
        },{
          name: '鸡西市',
          value: 13,
          order: '6'
        },{
          name: '绥化市',
          value: 7,
          order: '7'
        },{
          name: '黑河市',
          value: 6,
          order: '8'
        },{
          name: '鹤岗市',
          value: 5,
          order: '9'
        },{
          name: '伊春市',
          value: 2,
          order: '10'
        },{
          name: '七台河市',
          value: 1,
          order: '11'
        }]
      },
      {
        branchName: '被动器件',
        attrs: [{
          name: '哈尔滨市',
          value: 844,
          order: '1'
        },{
          name: '大庆市',
          value: 52,
          order: '2'
        },{
          name: '齐齐哈尔市',
          value: 39,
          order: '3'
        },{
          name: '七台河市/牡丹江市',
          value: 26,
          order: '4'
        },

        {
          name: '佳木斯市',
          value: 19,
          order: '5'
        },
        {
          name: '双鸭山市',
          value: 11,
          order: '6'
        },
        {
          name: '绥化市',
          value: 10,
          order: '7'
        },
        {
          name: '鸡西市',
          value: 6,
          order: '8'
        },
        {
          name: '黑河市',
          value: 4,
          order: '9'
        },{
          name: '鹤岗市/伊春市',
          value: 3,
          order: '10'
        },
        {
          name: '大兴安岭地区',
          value: 2,
          order: '11'
        }]
      },
      {
        branchName: '专用材料',
        attrs: [{
          name: '哈尔滨市',
          value: 392,
          order: '1'
        },
        {
          name: '鸡西市',
          value: 7,
          order: '2'
        },
        {
          name: '大庆市',
          value: 6,
          order: '3'
        },
        {
          name: '佳木斯市/齐齐哈尔市',
          value: 3,
          order: '4'
        },
        {
          name: '牡丹江市',
          value: 2,
          order: '5'
        },
        {
          name: '鹤岗市',
          value: 1,
          order: '6'
        }
        ]
      },
      {
        branchName: '机电元器件',
        attrs: [{
          name: '哈尔滨市',
          value: 253,
          order: '1'
        },
        {
          name: '齐齐哈尔市',
          value: 36,
          order: '2'
        },
        {
          name: '大庆市',
          value: 28,
          order: '3'
        },
        {
          name: '绥化市',
          value: 22,
          order: '4'
        },
        {
          name: '佳木斯市',
          value: 17,
          order: '5'
        },
        {
          name: '鸡西市',
          value: 5,
          order: '6'
        },
        {
          name: '双鸭山市/牡丹江市',
          value: 4,
          order: '7'
        },
        {
          name: '大兴安岭地区/鹤岗市/黑河市',
          value: 2,
          order: '8'
        },
        {
          name: '伊春市',
          value:1,
          order: '9'
        }
        ]
      },
      {
        branchName: '温度测量仪',
        attrs: [{
          name: '哈尔滨市',
          value: 192,
          order: '1'
        },
        {
          name: '大庆市',
          value: 28,
          order: '2'
        },
        {
          name: '齐齐哈尔市',
          value: 17,
          order: '3'
        },
        {
          name: '佳木斯市/牡丹江市/黑河市',
          value: 4,
          order: '4'
        },
        {
          name: '鸡西市',
          value:3,
          order: '5'
        },
        {
          name: '双鸭山市',
          value: 2,
          order: '6'
        },
        {
          name: '伊春市/绥化市',
          value: 1,
          order: '7'
        }]
      },
      {
        branchName: '广播设备',
        attrs: [{
          name: '哈尔滨市',
          value: 133,
          order: '1'
        },
        {
          name: '黑河市',
          value: 35,
          order: '2'
        },{
          name: '齐齐哈尔市',
          value: 12,
          order: '3'
        },
        {
          name: '大庆市',
          value: 10,
          order: '4'
        },
        {
          name: '牡丹江市/鹤岗',
          value: 8,
          order: '5'
        },

        {
          name: '佳木斯市',
          value: 7,
          order: '6'
        },
        {
          name: '绥化市',
          value: 5,
          order: '7'
        },
        {
          name: '大兴安岭地区',
          value: 4,
          order: '8'
        },
        {
          name: '双鸭山市',
          value: 2,
          order: '9'
        },
        {
          name: '七台河/鸡西市',
          value: 1,
          order: '10'
        }]
      },
      {
        branchName: '雷达通信设备',
        attrs: [{
          name: '哈尔滨市',
          value: 105,
          order: '1'
        },
        {
          name: '伊春市/大庆市',
          value: 1,
          order: '2'
        }]
      },
      {
        branchName: '电压测量仪器',
        attrs: [{
          name: '哈尔滨市',
          value: 55,
          order: '1'
        },
        {
          name: '大庆市',
          value: 12,
          order: '2'
        },{
          name: '齐齐哈尔市',
          value: 7,
          order: '3'
        },{
          name: '双鸭山市',
          value: 3,
          order: '4'
        },{
          name: '佳木斯市/鸡西市/鹤岗市/黑河市区',
          value: 1,
          order: '5'
        }]
      },
      {
        branchName: '频率测量仪器',
        attrs: [{
          name: '哈尔滨市',
          value: 63,
          order: '1'
        },
        {
          name: '佳木斯市/牡丹江市',
          value: 2,
          order: '2'
        },
        {
          name: '绥化市/大庆市',
          value: 1,
          order: '3'
        }
        ]
      },
      {
        branchName: '电子工业模具及齿轮',
        attrs: [{
          name: '哈尔滨市',
          value: 44,
          order: '1'
        },
        {
          name: '齐齐哈尔市',
          value: 4,
          order: '2'
        },
        {
          name: '大庆市/牡丹江市/绥化市',
          value: 1,
          order: '3'
        }
        ]
      },
      {
        branchName: '电子真空器件专用设备',
        attrs: [{
          name: '哈尔滨市',
          value: 22,
          order: '1'
        }]
      }, 
      {
        branchName: '指挥自动化系统',
        attrs: [{
          name: '哈尔滨市',
          value: 3,
          order: '1'
        }]
      },
      {
        branchName: '电视设备',
        attrs: [{
          name: '哈尔滨市',
          value: 18,
          order: '1'
        },
        {
          name: '黑河市/七台河市',
          value: 2,
          order: '2'
        },
        {
          name: '鹤岗市/齐齐哈尔市',
          value: 1,
          order: '3'
        }
        ]
      },
      {
        branchName: '未分类',
        attrs: [{
          name: '哈尔滨市',
          value: 156,
          order: '1'
        },
        {
          name: '齐齐哈尔市',
          value: 4,
          order: '2'
        },
        {
          name: '佳木斯市',
          value: 3,
          order: '3'
        },
        {
          name: '牡丹江市',
          value: 1,
          order: '4'
        }
        ]
      },
    ];
    const options = [
    {
      value: '0',
      label: '主动器件',
    },
    {
      value: '1',
      label: '被动器件',
    },
        {
      value: '2',
      label: '专用材料',
    },
    {
      value: '3',
      label: '机电元器件',
    },
    {
        value: '4',
        label: '温度测量仪',
    },
    {
        value: '5',
        label: '广播设备',
    },
    {
        value: '6',
        label: '雷达通信设备',
    },
    {
        value: '7',
        label: '电压测量仪器',
    },
    {
        value: '8',
        label: '频率测量仪器',
    },
        {
        value: '9',
        label: '电子工业模具及齿轮',
    },
    {
        value: '10',
        label: '电子真空器件专用设备',
    },
    {
        value: '11',
        label: '指挥自动化系统',
    },
        {
        value: '12',
        label: '电视设备',
    },
    {
        value: '13',
        label: '未分类',
    },
    ]
    let cityValue = ref('0');
    let areaName = ref('0');
    let currentArea= ref(areaDatas[0]);
    function scrollUp() {
      nextTick(()=>{
      const myList = document.getElementById('areaEchart2');
      const tableScroll = ref(true);
      myList.addEventListener('mouseover',()=>{
        tableScroll.value = false;
      })
      myList.addEventListener('mouseout',()=>{
        tableScroll.value = true;
      })
      timer = setInterval(()=>{
        if(tableScroll.value) {
          myList.scrollTop += 1;
          if(myList.clientHeight + myList.scrollTop >= myList.scrollHeight) {
            myList.scrollTop = 0;
          }
        }
      },150)
      })
    }
    function clearScrll() {
      clearInterval(timer)
      timer = null;
    }
    onMounted(() => {
      scrollUp()
      //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[2043,1122,338,233,1]);
    });
    onUnmounted(() => {
      clearScrll();
    });
    // function industryEchart(xData, yData) {
    //   let chart = echart.init(document.getElementById("areaEchart"));
    //   // 把配置和数据放这里
    //   chart.setOption({
    //     tooltip: {
    //       trigger: 'axis'
    //     },
    //     grid: {
    //       bottom: '30%'
    //     },
    //     xAxis: {
    //         type: 'category',
    //         data: xData,
    //         axisLabel: {
    //           show: true, // 是否显示刻度标签，默认显示
    //           interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
    //           rotate: 46, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
    //           inside: false, // 刻度标签是否朝内，默认朝外
    //           margin: 6, // 刻度标签与轴线之间的距离
    //           color: '#fff',
    //           fontSize: '14px',
    //         },
    //       },
    //       yAxis: {
    //         type: 'value',
    //         axisLabel: {
    //           color: '#fff',
    //           fontSize: '14px',
    //         },
    //       },
    //       series: [
    //         {
    //           data: yData,
    //           type: 'bar',
    //           itemStyle: {
    //             normal: {
    //             color:'#02eeea',
    //             label: {
    //               show: true,
    //               position: 'top',
    //               textStyle: {
    //                   color: '#fff',
    //                   fontSize: '14px'
    //               }
    //             }
    //             }
    //           }
    //         }
    //       ]
    // });
    //   window.onresize = function() {
    //     //自适应大小
    //     chart.resize();
    //   };
    // }
    function handleChangeCity(val) {
      areaName.value = val;
      currentArea.value = areaDatas[val];
      if(val == '主动器件') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[2043,1122,338,233,1]);
      }
      if(val == '被动器件') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[44,102,97,6,2]);
      }
      if(val == '专用材料') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[31,51,61,0,1]);
      }
      if(val == '机电元器件') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[20,30,26,0,2]);
      }
    }
    function cityChange(val) {
      cityValue.value = val;
      currentArea.value = areaDatas[val];
      if(val == '温度测量仪') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[1,27,38,1,0]);
      }
      if(val == '广播设备') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[2,6,41,0,0]);
      }
      if(val == '未分类') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[7,14,23,0,0]);
      }
      if(val == '雷达通信设备') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[5,14,15,0,0]);
      }
      if(val == '电压测量仪器') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[0,7,23,0,0]);
      }
      if(val == '频率测量仪器') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[1,3,19,0,0]);
      }
      if(val == '电子工业模具及齿轮') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[1,2,13,1,0]);
      }
      if(val == '指挥自动化系统') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[1,4,4,0,0]);
      }
      if(val == '电子真空器件专用设备') {
        //industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[0,3,4,0,0]);
      }
    }
    return { areaName, cityValue, options, areaDatas,cityChange, handleChangeCity,currentArea, clearScrll, timer};
  }
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .industryBox label{
  margin-left: 10px;
  margin-top: 10px;
} */
 .tag{
  margin: 20px auto;
  margin-bottom: 20px;
 }
 .tag span{
  padding: 6px;
  cursor: pointer;
  display: inline-block;
  margin: 2px;
  width: 140px;
  font-size: 14px;
  text-align: center;
  background: #004296;
 }
 .tag span.active{
  color: #fff;
  font-weight: 500;
  background: #0071ff;
 }
 #areaEchart{
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
 }
 #areaEchart p{
  color: #409eff;
 }
 .areaEchart {
  display: flex;
  justify-content: space-between;
 }
 .areaEchart p, #areaEchart p{
  text-align: left;
 }
 .areaEchart p:nth-child(1), #areaEchart p:nth-child(1) {
  width: 20%;
 }
.areaEchart p:nth-child(2), #areaEchart p:nth-child(2) {
  width: 60%;
 }
.areaEchart p:nth-child(3), #areaEchart p:nth-child(3) {
  width: 20%;
 }
 #areaEchart2{
  height: 360px;
  overflow-y: auto;
 }
 #areaEchart2 .areaEchart{
  padding: 10px;
  background: linear-gradient(45deg, #1c3068, #29639e);
  margin-bottom: 10px;
 }
 #areaEchart2::-webkit-scrollbar{
  width: 0px;
 }
 /deep/ .el-select{
  padding-left: 5px;
 }
</style>
